export default __webpack_public_path__ + "static/media/slowSkip.6b7e2ecb.png";